import React, { PropsWithChildren } from 'react'
import { remCalc } from 'utils'

const COUNT_STYLES =
  'm-auto text-secondary font-heading font-extrabold text-center leading-none'

interface ICountProps {
  margin?: string
  fontSize?: string
}

export const Count: React.FC<PropsWithChildren<ICountProps>> = ({
  margin,
  fontSize,
  children,
}) => {
  const COUNT_INLINE_STYLES = {
    margin: margin ?? 'auto',
    fontSize: fontSize ?? remCalc(28),
  }

  return (
    <p style={COUNT_INLINE_STYLES} className={COUNT_STYLES}>
      {children}
    </p>
  )
}

Count.displayName = 'Content.Count'
